import { render } from "./AppQuote.vue?vue&type=template&id=63f6946c&scoped=true"
import script from "./AppQuote.vue?vue&type=script&lang=js"
export * from "./AppQuote.vue?vue&type=script&lang=js"

import "./AppQuote.vue?vue&type=style&index=0&id=63f6946c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\alternativa-takeaway-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f6946c"]])

export default __exports__